var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1875 11.375H10.8125C10.6633 11.375 10.5202 11.4343 10.4148 11.5398C10.3093 11.6452 10.25 11.7883 10.25 11.9375C10.25 12.0867 10.3093 12.2298 10.4148 12.3352C10.5202 12.4407 10.6633 12.5 10.8125 12.5H11.375V22.625C11.375 22.9234 11.4935 23.2095 11.7045 23.4205C11.9155 23.6315 12.2016 23.75 12.5 23.75H21.5C21.7984 23.75 22.0845 23.6315 22.2955 23.4205C22.5065 23.2095 22.625 22.9234 22.625 22.625V12.5H23.1875C23.3367 12.5 23.4798 12.4407 23.5852 12.3352C23.6907 12.2298 23.75 12.0867 23.75 11.9375C23.75 11.7883 23.6907 11.6452 23.5852 11.5398C23.4798 11.4343 23.3367 11.375 23.1875 11.375ZM21.5 22.625H12.5V12.5H21.5V22.625ZM13.625 9.6875C13.625 9.53832 13.6843 9.39524 13.7898 9.28975C13.8952 9.18426 14.0383 9.125 14.1875 9.125H19.8125C19.9617 9.125 20.1048 9.18426 20.2102 9.28975C20.3157 9.39524 20.375 9.53832 20.375 9.6875C20.375 9.83668 20.3157 9.97976 20.2102 10.0852C20.1048 10.1907 19.9617 10.25 19.8125 10.25H14.1875C14.0383 10.25 13.8952 10.1907 13.7898 10.0852C13.6843 9.97976 13.625 9.83668 13.625 9.6875Z",
    fill: "#EA3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircle);
export default __webpack_public_path__ + "static/media/deleteCircle.6292e882f1022e2a3fd8b1212f77a767.svg";
export { ForwardRef as ReactComponent };